import { lazy } from 'react';
import { FuseRouteItemType } from '@fuse/utils/FuseUtils';

const Categories = lazy(() => import('./Categories'));
const CategoriesListView = lazy(() => import('./views/CategoriesListView'));
const CategoryFormView = lazy(() => import('./views/CategoryFormView'));

const CategoriesRoute: FuseRouteItemType = {
	path: '/catalog/categories',
	element: <Categories />,
	children: [
		{ index: true, element: <CategoriesListView /> },
		{ path: 'new', element: <CategoryFormView /> },
		{ path: ':id', element: <CategoryFormView /> }
	]
};

export default CategoriesRoute;
